import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import useUiContext from '@/custolink-hooks/useUiContext'
import { FrontendAssetScanApi } from '@/custolink-transpiled_by_server/bc.assets.api_methods'

/**
 * The serial-number lookup, lifted verbatim from `SearchTopPart` so all three
 * worlds keep the same behaviour: debounce the keystrokes, ask the same
 * endpoint, and hard-navigate to the asset or category view it resolves to.
 * Only the presentation differs between worlds.
 */
export default function useSerialLookup() {
  const uic = useUiContext()
  const [query, setQuery] = useState('')
  const [debouncedInput, setDebouncedInput] = useState('')

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedInput(query)
    }, 500)
    return () => clearTimeout(handler)
  }, [query])

  const q = useQuery({
    queryFn: () => FrontendAssetScanApi.assetLookup(uic._orgId, debouncedInput.trim()),
    queryKey: ['FrontendAssetScanApi', uic._orgId, debouncedInput],
    enabled: debouncedInput.trim().length > 0,
  })

  useEffect(() => {
    if (q.data?.defaultViewResult != null) {
      window.location.href = `/asset/${q.data.defaultViewResult.serialnumber}`
    } else if (q.data?.customViewResult != null) {
      window.location.href = `/view/${q.data.customViewResult.urlSlug}/${q.data.customViewResult.attrValue}`
    }
  }, [q.data])

  return {
    query,
    setQuery,
    isSearching: q.isFetching,
  }
}
